/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Schedule_Next_Run_DueInputs */



/**
* | output |
* | --- |
* | "Due, running shortly" |
*
* @param {Agent_Schedule_Next_Run_DueInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_schedule_next_run_due = /** @type {((inputs?: Agent_Schedule_Next_Run_DueInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Schedule_Next_Run_DueInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fällig, läuft gleich")
	return /** @type {LocalizedString} */ ("Due, running shortly")
});